import { fetchMePerm } from '@/api/user/me'

const perm = {
  state: {
    errs: [],
    inited: false,
    perms: [],
    permMap: {}
  },

  mutations: {
    ADD_ERR: (state, err) => {
      let cfg = err.response.config
      let isDup = false
      for (let i = 0; i < state.errs.length; i++) {
        let e = state.errs[i]
        if (e.method === cfg.method && e.url === cfg.url) {
          isDup = true
          break
        }
      }

      if (!isDup) {
        state.errs.push(cfg)
      }
    },
    RESET_ERR: (state) => {
      state.errs = []
    },
    SET_PERMS: (state, perms) => {
      state.inited = true
      state.perms = perms
      let permMap = {}
      if (perms && perms.routes && perms.routes.length > 0) {
        perms.routes.forEach(p => {
          permMap[`${p.method}${p.path}`] = true
        })
      }
      state.permMap = permMap
    }
  },

  actions: {
    AddPermErr ({ commit }, err) {
      commit('ADD_ERR', err)
    },
    ResetPermErr ({ commit }) {
      commit('RESET_ERR')
    },
    FetchMePerm ({ commit }) {
      if (this.state.perm.inited) {
        return new Promise((resolve) => {
          resolve(this.state.perm.perms)
        })
      }
      return new Promise((resolve, reject) => {
        fetchMePerm().then(res => {
          commit('SET_PERMS', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default perm
